/** Testi del modulo Attestati e report: area partecipante, verifica pubblica, admin. */
export const documenti = {
  nav: 'I miei attestati',
  attestati: {
    titolo: 'I miei attestati',
    sottotitolo: 'Un attestato per ogni webinar con il test superato. Il codice in basso serve a chi deve verificarlo.',
    nessunoTitolo: 'Nessun attestato ancora',
    nessunoTesto: 'L’attestato nasce quando superi il test finale di un webinar: lo trovi qui e arriva anche via email.',
    scarica: 'Scarica l’attestato',
    inPreparazione: 'In preparazione',
    inPreparazioneTesto: 'Lo stiamo preparando: arriva anche via email. Di solito bastano pochi minuti.',
    pronto: 'Pronto',
    errore: 'Non ancora disponibile',
    erroreTesto: 'Qualcosa non ha funzionato nella preparazione: l’organizzatore è avvisato. Se non arriva, contattalo.',
    revocato: 'Revocato',
    revocatoTesto: 'Questo attestato è stato revocato dall’organizzatore: contattalo per capire il motivo.',
    codice: 'Codice di verifica',
    copia: 'Copia',
    copiato: 'Copiato',
    presenza: (minuti: string, pct: number) => `Presenza ${minuti} · ${pct}%`,
    emessoIl: (data: string) => `Emesso il ${data}`,
    vaiAiTuoi: 'Vai ai tuoi attestati',
    verificaLink: 'Verifica un attestato',
  },
  verifica: {
    titolo: 'Verifica un attestato',
    sottotitolo: 'Inserisci il codice stampato sull’attestato, 12 caratteri. Il QR sull’attestato porta direttamente qui.',
    campo: 'Codice di verifica',
    aiuto: 'Per esempio: ABCD-2345-EFGH. Le lettere maiuscole o minuscole non contano.',
    azione: 'Verifica',
    inCorso: 'Verifica in corso',
    validoTitolo: 'Attestato valido',
    validoTesto: 'Emesso da Aulaviva per la partecipazione al webinar indicato, con test finale superato.',
    revocatoTitolo: 'Attestato revocato',
    revocatoTesto: 'Questo attestato è stato revocato dall’organizzatore e non è più valido.',
    nonTrovatoTitolo: 'Nessun attestato con questo codice',
    nonTrovatoTesto: 'Controlla di averlo copiato bene: sono 12 caratteri, senza spazi. Se il problema resta, chiedi a chi te lo ha consegnato.',
    campi: {
      intestatario: 'Intestatario',
      webinar: 'Webinar',
      percorso: 'Percorso',
      data: 'Data',
      presenza: 'Presenza',
      test: 'Test finale',
      testSuperato: 'Superato',
      emesso: 'Emesso il',
      codice: 'Codice',
    },
    codiceNonValido: 'Il codice ha 12 caratteri: controlla di averli inseriti tutti.',
    altroCodice: 'Verifica un altro codice',
  },
  admin: {
    attestati: {
      scheda: 'Attestati',
      titolo: 'Attestati',
      sottotitolo: 'Nascono da soli quando un iscritto supera il test. Da qui li scarichi, li rigeneri o li revochi con un motivo.',
      riepilogo: { totale: 'Totale', pronti: 'Pronti', inCoda: 'In coda', errori: 'Errori', revocati: 'Revocati' },
      cerca: 'Cerca per nome o email',
      filtro: 'Stato',
      tutti: 'Tutti',
      stati: { in_coda: 'In coda', pronto: 'Pronti', errore: 'Con errore', revocato: 'Revocati' } as const,
      badge: { in_coda: 'In coda', pronto: 'Pronto', errore: 'Errore', revocato: 'Revocato' } as const,
      colonne: { nome: 'Nome', email: 'Email', codice: 'Codice', stato: 'Stato', emesso: 'Emesso', emailInviata: 'Email', azioni: 'Azioni' },
      emailInviata: (quando: string) => `Inviata ${quando}`,
      emailNonInviata: 'Non inviata',
      scarica: 'Scarica',
      rigenera: 'Rigenera',
      rigenerato: 'Attestato rimesso in coda: pronto tra pochi minuti.',
      revoca: 'Revoca',
      revocaTitolo: 'Revocare l’attestato?',
      revocaTesto: (nome: string) => `${nome} non potrà più scaricarlo e la verifica pubblica dirà che è revocato. Il motivo resta nel registro. Non si può annullare.`,
      revocaMotivo: 'Motivo della revoca',
      revocaConferma: 'Sì, revoca',
      revocato: 'Attestato revocato.',
      generaMancanti: 'Genera i mancanti',
      generaMancantiTitolo: 'Generare gli attestati mancanti?',
      generaMancantiTesto: 'Per ogni iscritto con il test superato e senza attestato verrà creato l’attestato e inviata l’email. Chi ce l’ha già non riceve nulla.',
      generaMancantiConferma: 'Sì, genera',
      generati: (n: number) => (n === 1 ? 'Messo in coda 1 attestato.' : `Messi in coda ${n} attestati.`),
      nessuno: 'Nessun attestato ancora: nascono quando un iscritto supera il test.',
      nessunRisultato: 'Nessun attestato corrisponde alla ricerca.',
      didascalia: 'Attestati del webinar',
      erroreDettaglio: 'Errore',
    },
    report: {
      scheda: 'Report',
      titolo: 'Report del webinar',
      sottotitolo: 'Il file Excel con presenze, ingressi e uscite, esiti del test e domande. Parte da solo alla chiusura del test e va all’organizzatore.',
      genera: 'Genera il report ora',
      generaTitolo: 'Generare il report adesso?',
      generaTesto: 'Verrà inviato all’organizzatore e ai contatti che ricevono i report. Se lo generi prima della chiusura del test, i dati sono quelli di questo momento.',
      generaConferma: 'Sì, genera e invia',
      messoInCoda: 'Report in preparazione: compare qui tra pochi minuti e parte via email.',
      scarica: 'Scarica',
      colonne: { stato: 'Stato', generato: 'Generato', inviatoA: 'Inviato a', richiestoDa: 'Richiesto da', file: 'File' },
      automatico: 'Automatico',
      nonInviato: 'Non inviato',
      nessuno: 'Nessun report ancora: il primo parte da solo alla chiusura del test.',
      badge: { in_coda: 'In preparazione', pronto: 'Pronto', errore: 'Errore' } as const,
      didascalia: 'Report generati per questo webinar',
      vaiAiReport: 'Vai ai report',
      direttaChiusaTitolo: 'Test chiuso: il report è in arrivo',
      direttaChiusaTesto: 'Alla chiusura del test il report Excel parte da solo verso l’organizzatore. Lo trovi anche nel dettaglio del webinar.',
    },
  },
};
